import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ImageSlider from '../components/ImageSlider';
import './styles/Home.css';

const Home = () => {
  // Slider images - using local images from public/images folder
  const sliderImages = [
    {
      image: '/images/curcuma_zedoaria.jpeg',
      title: 'Welcome to SARKAR TRADERS',
      description: 'Your trusted partner in quality products and services'
    },
    {
      image: '/images/chia_seeds.jpeg',
      title: 'Chia Seeds',
      description: 'Chia Seeds are a rich source of omega-3 fatty acids and fiber, making them a healthy addition to your diet.'
    },
    {
      image: '/images/aswagandha_roots.jpeg',
      title: 'Aswagandha Roots',
      description: 'Aswagandha Roots are known for their adaptogenic properties and are used in traditional medicine for stress relief and immune support.'
    },
    {
      image: '/images/marathi_moggu.jpeg',
      title: 'Mrathi Moggu',
      description: 'Marathi Moggu is a traditional Indian spice known for its aromatic and flavorful properties.'
    },
    {
      image: '/images/turmeric.jpg',
      title: 'Turmeric',
      description: 'Turmeric is a powerful spice known for its anti-inflammatory and antioxidant properties.'
    }
  ];

  // Sample products - replace with actual products
  const featuredProducts = [
    {
      id: 1,
      name: 'Curcuma Zedoary',
      description: 'Curcuma Zedoary is a fragrant root known for its medicinal properties and use as a natural spice and herbal remedy.',
      image: '/images/curcuma_zedoaria.jpeg',
    },
    {
      id: 2, 
      name: 'Aswagandha Roots',
      description: 'Aswagandha Roots are known for their adaptogenic properties and are used in traditional medicine for stress relief and immune support.',
      image: '/images/aswagandha_roots.jpeg',
    },
    {
      id: 3,
      name: 'Marathi Moggu',
      description: 'Marathi Moggu is a traditional Indian spice known for its aromatic and flavorful properties.',
      image: '/images/marathi_moggu.jpeg',
    },
    {
      id: 4,
      name: 'Chia Seeds',
      description: 'Chia Seeds are a rich source of omega-3 fatty acids and fiber, making them a healthy addition to your diet.',
      image: '/images/chia_seeds.jpeg',
    },
    {
      id: 5,
      name: 'Garlic',
      description: 'Garlic is a versatile and flavorful ingredient known for its health benefits and culinary uses.',
      image: '/images/garlic.jpg',
    },
    {
      id: 6,
      name: 'Turmeric',
      description: 'Turmeric is a powerful spice known for its anti-inflammatory and antioxidant properties.',
      image: '/images/turmeric.jpg',
    }
  ];

  return (
    <>
      <Helmet>
        <title>Home - SARKAR TRADERS</title>
        <meta name="description" content="Welcome to SARKAR TRADERS - Your trusted partner in quality products. Located in Domkal, Murshidabad, West Bengal." />
      </Helmet>
      
      <div className="home-page">
        {/* Image Slider */}
        <section className="slider-section">
          <ImageSlider slides={sliderImages} />
        </section>

        {/* Company Description */}
        <section className="company-description">
          <div className="container">
            <div className="description-content">
              <h2>Welcome to SARKAR TRADERS</h2>
              <p>
                SARKAR TRADERS is a leading trading company based in Domkal, Murshidabad, West Bengal. 
                With twenty years of experience in the industry, we have established ourselves as a trusted 
                partner for quality products and exceptional service. Our commitment to excellence 
                and customer satisfaction has made us a preferred choice for businesses and individuals 
                across the region.
              </p>
              <p>
                We specialize in providing a wide range of high-quality products that meet the diverse 
                needs of our customers. Our team is dedicated to maintaining the highest standards of 
                quality and ensuring timely delivery of all our products.
              </p>
              <Link to="/about" className="about-btn">
                Learn More About Us
              </Link>
            </div>
          </div>
        </section>

        {/* Featured Products */}
        <section className="featured-products">
          <div className="container">
            <h2>Our Featured Products</h2>
            <div className="products-grid">
              {featuredProducts.map((product) => (
                <div key={product.id} className="product-card">
                  <div className="product-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-info">
                    <h3>{product.name}</h3>
                    <p>{product.description}</p>
                    <Link to={`/products#product-${product.id}`} className="product-link">
                      View Details →
                    </Link>
                  </div>
                </div>
              ))}
            </div>
            <div className="view-all-products">
              <Link to="/products" className="view-all-btn">
                View All Products
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;

